import { render, staticRenderFns } from "./PromotionList.vue?vue&type=template&id=30c79a1c&"
import script from "./PromotionList.vue?vue&type=script&lang=ts&"
export * from "./PromotionList.vue?vue&type=script&lang=ts&"
import style0 from "./PromotionList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports